<app-create-asin-header></app-create-asin-header>

<div style="{{ minHeight }}" class="ca-bg">
  <div class="container mb-4" style="{{ minHeight2 }}">
    <div style="padding: 50px 30px">
      <div class="row justify-content-center">
        <div class="col-lg-10 col-xl-7">
          <div class="question-card">
            <h6
              style="
                padding: 15px;
                font-family: Helvetica Neue;
                border-bottom: 1px solid #d9d8d8;
              "
            >
              OTHER INFORMATION -- {{ biodata }}
            </h6>

            <form
              [formGroup]="basicForm"
              (ngSubmit)="submit()"
              style="background-color: #fefefe; padding: 10px 40px"
            >
              <ng-container>
                <!-- EMPLOYMENT & INCOME DETAILS -->
                <div class="section box-with-text">
                  <span class="box-title">EMPLOYMENT & INCOME DETAILS:</span>
                  <div class="row g-3 align-items-end">
                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Income Category</label>
                      <select
                        formControlName="incomeCategory"
                        class="form-select"
                      >
                        <option disabled [selected]="true">
                          -- Select Income Category --
                        </option>
                        <option value="employed">Employed</option>
                        <option value="selfEmployed">Self Employed</option>
                        <option value="unemployed">Unemployed</option>
                      </select>
                      <app-error-message
                        controlName="incomeCategory"
                        label="Income Category"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div
                      class="col-md-6 col-lg-4 tax-input-group"
                      *ngIf="
                        basicForm.get('incomeCategory')?.value == 'employed'
                      "
                    >
                      <label>Name Of Employer</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="employerName"
                        placeholder="Enter Employer Name"
                      />
                      <app-error-message
                        controlName="employerName"
                        label="Employer Name"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div
                      class="col-md-6 col-lg-4 tax-input-group"
                      *ngIf="
                        basicForm.get('incomeCategory')?.value == 'employed'
                      "
                    >
                      <label>Income/Salary Range Per Annum</label>
                      <select formControlName="incomeRange" class="form-select">
                        <option disabled [selected]="true">
                          -- Select Income Range --
                        </option>
                        <option value="₦100,000 – ₦1,000,000">
                          ₦100,000 – ₦1,000,000
                        </option>
                        <option value="₦1,001,000 – ₦5,000,000">
                          ₦1,001,000 – ₦5,000,000
                        </option>
                        <option value="₦501,000 - 10,000,000">
                          ₦501,000 - 10,000,000
                        </option>
                        <option value="₦10,001,000 - 20,000,000">
                          ₦10,001,000 - 20,000,000
                        </option>
                        <option value="₦20,001,000 - 50,000,000">
                          ₦20,001,000 - 50,000,000
                        </option>
                        <option value="Above 50,000,000">
                          Above 50,000,000
                        </option>
                      </select>
                      <app-error-message
                        controlName="incomeRange"
                        label="Income Range"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div
                      class="col-md-6 col-lg-4 tax-input-group"
                      *ngIf="
                        basicForm.get('incomeCategory')?.value == 'selfEmployed'
                      "
                    >
                      <label>Industry</label>
                      <select
                        class="form-control small-option-font"
                        formControlName="natureOfBusiness"
                      >
                        <option value="">-- Select--</option>
                        <option [value]="0">Uncategorized</option>
                        <option
                          [value]="businessNature?.id"
                          *ngFor="let businessNature of businessNatureList"
                        >
                          {{ businessNature?.name | titlecase }}
                        </option>
                      </select>
                    </div>
                    <div
                      class="col-md-6 col-lg-4 tax-input-group"
                      *ngIf="
                        basicForm.get('incomeCategory')?.value ==
                          'selfEmployed' ||
                        basicForm.get('incomeCategory')?.value == 'unemployed'
                      "
                    >
                      <label>Source Of Income</label>
                      <ng-select
                        [items]="sourceOfIncome"
                        bindLabel="name"
                        placeholder="-- Select Source of Income --"
                        formControlName="sourceOfIncome"
                      ></ng-select>
                      <app-error-message
                        controlName="sourceOfIncome"
                        label="Source of Income"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div
                      class="col-md-6 col-lg-4 tax-input-group"
                      *ngIf="
                        basicForm.get('incomeCategory')?.value ==
                          'selfEmployed' ||
                        basicForm.get('incomeCategory')?.value == 'unemployed'
                      "
                    >
                      <label>Total Annual Income(₦)</label>
                      <input
                        class="form-control"
                        formControlName="totalAnnualIncome"
                        type="number"
                        min="0"
                        placeholder="Enter Total Annual Income"
                      />
                      <app-error-message
                        controlName="totalAnnualIncome"
                        label="Total Annual Income"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                    <div class="col-md-6 col-lg-6">
                      <div>
                        <label>Highest Level of Education</label><br />
                        <ng-select
                          [items]="mediaOptions"
                          bindLabel="name"
                          [multiple]="false"
                          placeholder="Select highest level of education..."
                          formControlName="educationLevel"
                        >
                        </ng-select>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- CONTACT INFORMATION -->
                <div class="section box-with-text">
                  <span class="box-title"
                    >CONTACT/RESIDENTIAL INFORMATION:</span
                  >
                  <div class="row g-3 align-items-end">
                    <div class="col-md-6 col-lg-6 tax-input-group">
                      <label>State of Origin</label>
                      <ng-select
                        (change)="onStateOfOriginChange()"
                        [items]="state"
                        bindLabel="name"
                        placeholder="-- Select State --"
                        formControlName="stateOfOrigin"
                      ></ng-select>
                      <app-error-message
                        controlName="state"
                        label="State"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div class="col-md-6 col-lg-6 tax-input-group">
                      <label>LGA of Origin</label>
                      <ng-select
                        [items]="lgas"
                        bindLabel="name"
                        placeholder="-- Select LGA --"
                        formControlName="lgaOfOrigin"
                      ></ng-select>
                      <app-error-message
                        controlName="lga"
                        label="LGA"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>State of Residence</label>
                      <ng-select
                        (change)="onStateChange()"
                        [items]="state"
                        bindLabel="name"
                        placeholder="-- Select State --"
                        formControlName="state"
                      ></ng-select>
                      <app-error-message
                        controlName="state"
                        label="State"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>LGA of Residence</label>
                      <ng-select
                        [items]="lgas"
                        bindLabel="name"
                        placeholder="-- Select LGA --"
                        formControlName="lga"
                      ></ng-select>
                      <app-error-message
                        controlName="lga"
                        label="LGA"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Nearest Landmark</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter Nearest landmark"
                        formControlName="landMark"
                      />
                      <app-error-message
                        controlName="landMark"
                        label="Nearest landmark"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div class="col-md-12 col-lg-12 tax-input-group">
                      <label>Residential Address</label>
                      <textarea
                        class="form-control"
                        formControlName="address"
                        placeholder="Enter Address"
                        cols="120"
                        rows="3"
                      ></textarea>
                      <app-error-message
                        controlName="address"
                        label="Address"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                  </div>
                </div>

                <!-- RENT INFORMATION -->
                <div class="section box-with-text">
                  <span class="box-title">ACCOMMODATION INFORMATION:</span>
                  <div class="row g-3 align-items-end">
                    <div class="col-md-6 col-lg-6 tax-input-group">
                      <label>Accommodation Type</label>
                      <select
                        formControlName="accommodationType"
                        class="form-select"
                      >
                        <option disabled selected>
                          -- Select Accommodation Type --
                        </option>
                        <option value="rented">Rented</option>
                        <option value="owned">Owner Occupier</option>
                        <option value="leased">Leased</option>
                      </select>
                      <app-error-message
                        controlName="accommodationType"
                        label="Accommodation Type"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                    <div
                      class="col-md-6 tax-input-group"
                      *ngIf="
                        basicForm?.get('accommodationType')?.value == 'owned'
                      "
                    >
                      <label>Building Type</label>
                      <select
                        formControlName="buildingType"
                        class="form-select"
                      >
                        <option disabled selected>
                          -- Select Building Type --
                        </option>
                        <option value="bungalow">Bungalow</option>
                        <option value="flat">Flat</option>
                        <option value="duplex">Duplex</option>
                      </select>
                      <app-error-message
                        controlName="buildingType"
                        label="Building Type"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                    <div
                      class="col-md-6 tax-input-group"
                      *ngIf="
                        ['rented', 'leased'].includes(
                          basicForm.get('accommodationType').value
                        )
                      "
                    >
                      <label>Period Type</label>
                      <select formControlName="periodType" class="form-select">
                        <option disabled selected>
                          -- Select Period Type --
                        </option>
                        <option value="monthly">Monthly</option>
                        <option value="yearly">Yearly</option>
                        <option value="bi-annual">Bi-Annual</option>
                      </select>
                      <app-error-message
                        controlName="periodType"
                        label="Period Type"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                    <div
                      class="col-md-6 tax-input-group"
                      *ngIf="
                        ['bungalow', 'duplex', 'flat'].includes(
                          basicForm.get('buildingType').value
                        )
                      "
                    >
                      <label>No. of Rooms</label>
                      <input
                        type="number"
                        class="form-select"
                        formControlName="numberOfRooms"
                        min="1"
                        placeholder="Enter No. of Rooms"
                      />
                      <app-error-message
                        controlName="periodType"
                        label="Period Type"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div
                      class="col-md-6 tax-input-group"
                      *ngIf="
                        ['rented', 'leased'].includes(
                          basicForm.get('accommodationType')?.value
                        )
                      "
                    >
                      <label>Management Type</label>
                      <select
                        formControlName="propertyManagement"
                        class="form-select"
                      >
                        <option disabled selected>
                          -- Select Management Type --
                        </option>
                        <option value="Landlord">Landlord</option>
                        <option value="Caretaker">Caretaker</option>
                        <option value="Property Manager">
                          Property Manager
                        </option>
                      </select>
                      <app-error-message
                        controlName="propertyManagement"
                        label="Management Type"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                    <div
                      class="col-md-6 col-lg-6 tax-input-group"
                      *ngIf="
                        ['rented', 'leased'].includes(
                          basicForm.get('accommodationType').value
                        )
                      "
                    >
                      <label>Rent Period Covered</label>
                      <mat-form-field appearance="fill" class="form-control">
                        <mat-label>Year Range</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                          <input
                            matStartDate
                            formControlName="rentPeriodCoveredStart"
                            placeholder="Start Date"
                          />
                          <input
                            matEndDate
                            formControlName="rentPeriodCoveredEnd"
                            placeholder="End Date"
                          />
                        </mat-date-range-input>
                        <mat-datepicker-toggle
                          matSuffix
                          [for]="picker"
                        ></mat-datepicker-toggle>

                        <mat-date-range-picker
                          #picker
                          startView="multi-year"
                          (monthSelected)="chosenMonthHandler($event, picker)"
                        >
                        </mat-date-range-picker>
                      </mat-form-field>
                      <app-error-message
                        controlName="rentPeriodCovered"
                        label="Rent Period Covered"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                    <div
                      class="col-md-6 tax-input-group"
                      *ngIf="
                        ['rented', 'leased'].includes(
                          basicForm.get('accommodationType').value
                        )
                      "
                    >
                      <label>Annual Rent Amount</label>
                      <input
                        type="number"
                        class="form-control"
                        formControlName="annualRentAmount"
                      />
                      <app-error-message
                        controlName="annualRentAmount"
                        label="Annual Rent Amount"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                  </div>
                </div>

                <!-- LANDLORD INFORMATION -->
                <div
                  class="section box-with-text"
                  *ngIf="
                    ['rented', 'leased'].includes(
                      basicForm.get('accommodationType').value
                    )
                  "
                >
                  <span class="box-title">LANDLORD INFORMATION:</span>
                  <div class="row g-3 align-items-end">
                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Full Name</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="landlordFullName"
                        placeholder="Enter Full Name"
                      />
                      <app-error-message
                        controlName="landlordFullName"
                        label="Landlord Full Name"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Phone Number</label>
                      <input
                        type="tel"
                        class="form-control"
                        formControlName="landlordPhoneNumber"
                        placeholder="Enter Phone Number"
                      />
                      <app-error-message
                        controlName="landlordPhoneNumber"
                        label="Landlord Phone Number"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>ASIN (Optional)</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="landlordAsin"
                        placeholder="Enter ASIN"
                      />
                      <app-error-message
                        controlName="landlordAsin"
                        label="ASIN"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Email (Optional)</label>
                      <input
                        type="email"
                        class="form-control"
                        formControlName="landlordEmail"
                        placeholder="Enter Email Address"
                      />
                      <app-error-message
                        controlName="landlordEmail"
                        label="Landlord Email"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Does Landlord Live In Same Apartment?</label>
                      <select
                        formControlName="doesLandlordLiveSameApartment"
                        class="form-select"
                      >
                        <option disabled selected>-- Select Option --</option>
                        <option [value]="true">Yes</option>
                        <option [value]="false">No</option>
                      </select>
                      <app-error-message
                        controlName="doesLandlordLiveSameApartment"
                        label="Does Landlord Live Same Apartment"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div
                      class="col-md-6 col-lg-4 tax-input-group"
                      *ngIf="
                        basicForm.get('doesLandlordLiveSameApartment')
                          ?.value === 'false'
                      "
                    >
                      <label>Address</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="landlordAddress"
                        placeholder="Enter Address"
                      />
                      <app-error-message
                        controlName="landlordAddress"
                        label="Landlord Address"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                  </div>
                </div>

                <!-- LIFESTYLE/ASSET INFORMATION -->
                <div class="section box-with-text">
                  <span class="box-title">PROPERTY/ASSET INFORMATION:</span>
                  <div class="row">
                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Do you have a vehicle?</label>
                      <select formControlName="hasVehicle" class="form-select">
                        <option disabled [selected]="true">
                          -- Select Option --
                        </option>
                        <option [value]="true">Yes</option>
                        <option [value]="false">No</option>
                      </select>
                      <app-error-message
                        controlName="hasVehicle"
                        label="Option"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                    <div
                      class="col-md-6 col-lg-4 tax-input-group"
                      *ngIf="basicForm.get('hasVehicle')?.value == 'true'"
                    >
                      <label>How Many Vehicles Owned?</label>
                      <input
                        type="number"
                        min="1"
                        formControlName="numberOfVehicles"
                        class="form-control"
                      />

                      <app-error-message
                        controlName="numberOfVehicles"
                        label="Number of Vehicles"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Do you have a property?</label>
                      <select formControlName="hasProperty" class="form-select">
                        <option disabled [selected]="true">
                          -- Select Option --
                        </option>
                        <option [value]="true">Yes</option>
                        <option [value]="false">No</option>
                      </select>
                      <app-error-message
                        controlName="hasProperty"
                        label="Option"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                    <div
                      class="col-md-6 col-lg-4 tax-input-group"
                      *ngIf="basicForm.get('hasProperty')?.value == 'true'"
                    >
                      <label>Assets/Property Type</label>
                      <ng-select
                        [items]="assetsOptions"
                        bindLabel="name"
                        [multiple]="true"
                        placeholder="Select highest level of education..."
                        formControlName="propertyType"
                      >
                      </ng-select>
                      <app-error-message
                        controlName="propertyType"
                        label="Property type"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Do you own a Business</label>
                      <select formControlName="hasBusiness" class="form-select">
                        <option disabled [selected]="true">
                          -- Select Item --
                        </option>
                        <option value="YES">Yes</option>
                        <option value="NO">No</option>
                      </select>
                      <app-error-message
                        controlName="hasBusiness"
                        label="Company type"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                  </div>
                </div>

                <!-- BUSINESS INFORMATION -->
                <div
                  class="section box-with-text p-4"
                  *ngIf="basicForm.get('hasBusiness').value == 'YES'"
                >
                  <span class="box-title">BUSINESS INFORMATION:</span>
                  <form
                    [formGroup]="businessForm"
                    (ngSubmit)="add()"
                    style="
                      background-color: white;
                      padding: 20px;
                      margin-bottom: 15px;
                      border-radius: 10px;
                      display: flex;
                      align-items: end;
                      gap: 10px;
                    "
                  >
                    <div class="row flex-wrap g-2">
                      <div
                        class="col-md-6 col-lg-4 tax-input-group"
                        style="flex: 1"
                      >
                        <label>Business Name</label>
                        <input
                          maxlength="100"
                          type="text"
                          formControlName="businessName"
                          class="form-control"
                        />
                        <app-error-message
                          controlName="businessName"
                          label="Business Name"
                          [form]="basicForm"
                        ></app-error-message>
                      </div>

                      <div
                        class="col-md-6 col-lg-4 tax-input-group"
                        style="flex: 1"
                      >
                        <label>Business ASIN</label>
                        <input
                          maxlength="11"
                          type="text"
                          formControlName="businessASIN"
                          class="form-control"
                        />
                        <app-error-message
                          controlName="businessASIN"
                          label="Business Asin"
                          [form]="basicForm"
                        ></app-error-message>
                      </div>
                    </div>
                    <button type="submit" class="btn btn-dark mb-1">+</button>
                  </form>

                  <table class="table" style="padding: 15px">
                    <thead class="thead-dark">
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Name</th>
                        <th scope="col">ASIN</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let item of basicForm?.get('businesses').value;
                          let i = index
                        "
                        style="vertical-align: middle"
                      >
                        <th scope="row">{{ i + 1 }}</th>
                        <td>{{ item.businessName }}</td>
                        <td>{{ item.businessASIN }}</td>
                        <td>
                          <button
                            type="button"
                            class="btn btn-danger"
                            (click)="remove(i)"
                          >
                            <small
                              style="font-size: 15px"
                              class="material-symbols-outlined text-white"
                            >
                              delete
                            </small>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- SUBMIT -->
                <div class="d-flex justify-content-center w-100">
                  <div class="submit-div">
                    <button type="submit" class="button px-3">Continue</button>
                  </div>
                </div>
              </ng-container>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>

<!-- Old Form -->
<!--
                    <div class="col-md-6 col-lg-6 ">
                      <div >
                        <label>Which of the following Electronic Devices do you own? (Select all that apply)</label><br>
                          <ng-select
                                  [items]="mediaOptions"
                                  bindLabel="name"
                                  bindValue="id"
                                  [multiple]="true"
                                  placeholder="Select media..."
                                  formControlName="lifestyleAsset">
                          </ng-select>
                      </div>
                      <app-error-message controlName="hasPurchasedAsset" label="Has Purchased Asset"
                        [form]="basicForm"></app-error-message>
                    </div>
                    <div class="col-md-6 col-lg-6 ">
                      <div >
                        <label>Which of the following Assets do you own? (Select all that apply)</label><br>
                          <ng-select
                                  [items]="assetsOptions"
                                  bindLabel="name"
                                  bindValue="id"
                                  [multiple]="true"
                                  placeholder="Select media..."
                                  formControlName="assetItems">
                          </ng-select>
                      </div>
                      <app-error-message controlName="hasPurchasedAsset" label="Has Purchased Asset"
                        [form]="basicForm"></app-error-message>
                    </div>

<form [formGroup]="basicForm" (ngSubmit)="submit()">
                            <div class="row mb-3">

                                <div class="col-md-6 mb-3">
                                    <div class="input-group-div">
                                        <label>Contact Address</label>
                                        <input formControlName="address" />
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="input-group-div">
                                        <label>State</label>
                                        <select formControlName="state" (change)="getLga()">
                                            <option value="6">ANAMBRA STATE</option>
                                            <option [value]="state.id" *ngFor="let state of state">{{state.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="input-group-div">
                                        <label>LGA</label>
                                        <select formControlName="lga" (change)="getArea()">
                                            <option value="">Select LGA</option>
                                            <option [value]="state.id" *ngFor="let state of lga">{{state.name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="input-group-div">
                                        <label>Area</label>
                                        <select formControlName="area">
                                            <option value="">Selete Area</option>
                                            <option [value]="state.id" *ngFor="let state of area">{{state.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <hr>
                 
                            <div class="row mb-3">
                                <div class="col-md-6 mb-3">
                                    <div class="input-group-div">
                                        <label>State Of Origin</label>
                                        <select formControlName="stateOfOrigin" (change)="getLga2()">
                                            <option value="6">Select State</option>
                                            <option [value]="state.id" *ngFor="let state of state2">{{state.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="input-group-div">
                                        <label>LGA Of Origin</label>
                                        <select formControlName="stateOfOriginLga" (change)="getArea2()">
                                            <option value="6">Select LGA</option>
                                            <option [value]="state.id" *ngFor="let state of lga2">{{state.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3" style="display: none">
                                    <div class="input-group-div">
                                        <label>Area Of Origin</label>
                                        <select formControlName="stateOfOriginArea">
                                            <option value="6">Select Area Council</option>
                                            <option [value]="state.id" *ngFor="let state of area2">{{state.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <div class="input-group-div">
                                        <label>Address</label>
                                        <input />
                                    </div>
                                </div>
                            </div>



                            <div class="row mb-3">

                                <div class="col-md-6">
                                    <div class="input-group-div">
                                        <label>Source Of Income</label>
                                        <select formControlName="sourceOfIncome">
                                            <option value="">Source of Income</option>
                                            <option [value]="state.id" *ngFor="let state of sourceOfIncome">
                                                {{state.name}}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <div class="input-group-div">
                                        <label>Highest Level Of Education</label>
                                        <select formControlName="highestEducation">
                                            <option>Select Higher Level of Education</option>
                                            <option>Ph'D</option>
                                            <option>MSC</option>
                                            <option>BSC</option>
                                            <option>BED</option>
                                            <option>BENG</option>
                                            <option>LLB</option>
                                            <option>HND</option>
                                            <option>NCE</option>
                                            <option>OND</option>
                                            <option>DIPLOMA</option>
                                            <option>WASSCE</option>
                                        </select>
                                    </div>
                                </div>

                            </div>
                            <br />
                            <div class="submit-div">
                                <button type="submit" class="button" [disabled]="basicForm.invalid">Continue</button>
                            </div>
                        </form> -->
